import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/denied/usage.deniedCustomer.query.gql"
import type {
  UsageLicenseDeniedCustomerQuery,
  UsageLicenseDeniedCustomerQueryVariables,
} from "@/v2-backoffice-client/usage/denied/__types__/usage.deniedCustomer.query"

type Options = QueryHookOptions<
  UsageLicenseDeniedCustomerQuery,
  UsageLicenseDeniedCustomerQueryVariables
>

export function useUsageLicenseDeniedCustomerQuery(options?: Options) {
  return useQuery<
    UsageLicenseDeniedCustomerQuery,
    UsageLicenseDeniedCustomerQueryVariables
  >(query, options)
}
